import { AppElement, html } from '../AppElement.js';
import Constants from '../Constants';
import {mapPriceRankPerSetRank} from '../StoryPitchMappings';

export default class StoryPositioningSubtitle extends AppElement {
    static get properties() {
        return {
            subtitle: { type: String },
            badgeClass: { type: String }
        };
    }

    constructor(props = {}) {
        super();

        this.recordDate = props.recordDate || Constants.MISSING_STR;
        this.stayDate = props.stayDate || Constants.MISSING_STR;
        this.hotel = props.hotel || {};

        this.empty();
    }

    reflow(props = {}) {
        this.recordDate = props.recordDate || Constants.MISSING_STR;
        this.stayDate = props.stayDate || Constants.MISSING_STR;
        this.hotel = props.hotel || {};
        this.fill();
    }

    empty() {
        this.subtitle = Constants.MISSING_STR;
        this.badgeClass = '';
    }

    fill() {
        if (
            typeof this.hotel !== 'object'
            || !this.hotel.id
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.recordDate)
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.stayDate)
        ) {
            this.empty();
            return;
        }

        let modelBiStats = window.infinito.vao.model.biStatistics;
        modelBiStats.fetchStatistics(
            this.hotel.id,
            modelBiStats.buildQuery({
                recordDate: this.recordDate,
                firstStayDate: this.stayDate,
                lastStayDate: this.stayDate,
                fields: [
                    modelBiStats.fields.priceRankLeadSiblingPace
                ]
            }),
            (data, procData) => {
                let priceRankLeadSiblingPace =
                    ((procData.priceRankLeadSiblingPace || {})[this.stayDate] || {}).value || null;

                if (
                    priceRankLeadSiblingPace
                    && typeof priceRankLeadSiblingPace === 'object'
                    && 'T0' in priceRankLeadSiblingPace
                    && 'setDenseRank' in priceRankLeadSiblingPace.T0
                    && 'setDenseLength' in priceRankLeadSiblingPace.T0
                    && $.isNumeric(priceRankLeadSiblingPace.T0.setDenseRank)
                ) {
                    let setRank = parseInt(priceRankLeadSiblingPace.T0.setDenseRank);
                    let setLength = priceRankLeadSiblingPace.T0.setDenseLength;
                    let mapVal = window.infinito.vao.controller.analyseAttributesHelper
                        .scaleRankMapForUniqueLength(
                            mapPriceRankPerSetRank,
                            setLength
                        )[setRank] || null;
                    if (mapVal) {
                        this.subtitle = mapVal;
                        if (mapVal === mapPriceRankPerSetRank[1]) {
                            this.badgeClass = Constants.BADGES.CLASSES.DANGER;
                        } else if (mapVal === mapPriceRankPerSetRank[5]) {
                            this.badgeClass = Constants.BADGES.CLASSES.SUCCESS; // Bottom of the pack is best?
                        } else {
                            this.badgeClass = Constants.BADGES.CLASSES.PRIMARY;
                        }
                    } else {
                        this.subtitle = Constants.MISSING_STR;
                    }
                } else {
                    this.subtitle = Constants.MISSING_STR;
                }
            }
        );
    }

    firstUpdated(changedProperties) {
        this.fill();
    }

    render() {
        return html`
<div class="${'vao__components--' + this.constructor.name}">
    <vao-story-subtitle subtitle="${this.subtitle}" badgeClass="${this.badgeClass}"></vao-story-subtitle>
</div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.StoryPositioningSubtitle = StoryPositioningSubtitle;
customElements.define('vao-story-positioning-subtitle', StoryPositioningSubtitle);
